import React, { useState } from 'react'
import { Zoom } from '../../Classroom/components/Frame/Tools'

const Image = ({ url }) => {
  const [scale, setScale] = useState(1.0)
  const zoomIn = () => {
    if (Math.round(scale * 100) / 100 >= 2.0) return
    setScale(scale + 0.1)
  }
  const zoomOut = () => {
    if (Math.round(scale * 100) / 100 <= 1.0) return
    setScale(scale - 0.1)
  }

  return (
    <div className='image-block'>
      <div className='image-container'>
        <img
          src={url}
          style={{
            transform: `scale(${scale})`,
            cursor: scale <= 1.0 ? 'zoom-in' : 'zoom-out'
          }}
          onClick={() => {
            return scale <= 1.0 ? setScale(2.0) : setScale(1.0)
          }}
        />
      </div>

      <Zoom onZoomIn={zoomIn} onZoomOut={zoomOut} style={{ bottom: 10 }} />
    </div>
  )
}

export default Image
